module.exports = __webpack_public_path__ + "img/ecommerce-website-listing.2ffe432b.jpg";